import { useMemo } from 'react';
// routes
import { paths } from 'src/routes/paths';
// locales
import { useLocales } from 'src/locales';
// components

import SvgColor from 'src/components/svg-color';
import mainMenuIcon from './reqIcon.png';
// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  menuIcn: <img src={mainMenuIcon} alt="logo" className="menuIconCss" />,
};

// ----------------------------------------------------------------------

export function useNavData() {
  const { t } = useLocales();

  const data = useMemo(
    () => [
      {
        subheader: t(''),
        items: [
          // USER
          {
            title: t('Work Request List'),
            path: paths.dashboard.work_request.list,
            icon: ICONS.menuIcn,
            className: 'ctmNav',
          },
        ],
      }
    ],
    [t]
  );

  return data;
}
